import { CompleteProfileResource } from '@backend/platform-api/resources/profile';
import { AgentResource, NewAgentResource } from '@backend/platform-api/resources/agents';
import { AgencyResource, NewAgencyResource } from '@backend/platform-api/resources/agency';
import { SchoolResource } from '@backend/platform-api/resources/schools';
import { SimpleResponse } from '@applyboard/school-backend-lib';

export type ProfileData = CompleteProfileResource['attributes'] & {
  id: string;
  schoolId: string;
};

export type AgentData = AgentResource['attributes'] & {
  id: string;
};

export type AgencyData = AgencyResource['attributes'] & {
  id: string;
};

export type SchoolData = SchoolResource['attributes'] & {
  id: string;
};

export enum Action {
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum UserType {
  owner = 'owner',
  admin = 'admin',
  staff = 'staff',
}

export enum PersonaType {
  admission = 'admission',
  agent = 'agent',
  student = 'student',
}

export enum ProfileState {
  active = 'active',
  inactive = 'inactive',
}

export type EditProfileProps = {
  id: string;
  profileData: Partial<CompleteProfileResource['attributes']>;
};

export type CreateProfileProps = Omit<CompleteProfileResource['attributes'], 'state'>;

export type CreateAgentProps = NewAgentResource['attributes'];

export type CreateAgencyProps = NewAgencyResource['attributes'];

export enum App {
  ApplySolutions = 'ApplySolutions',
  TrainHub = 'TrainHub',
  AMS = 'AMS',
  EnrolmentPlanner = 'EnrolmentPlanner',
}

export type ConfirmPasswordParams = {
  username: string;
  temporaryPassword: string;
  newPassword: string;
};

// this local type was added temporarily while we do not cleanup cognito from the ui
// if we use the type from the bff, a few attributes will be missing and a lot of code will need to be updated

export type FrontendConfigResponse = {
  type: 'frontend-config';
  id: 'frontend-config';
  attributes: {
    userPoolId: string;
    userPoolClientId: string;
    cognitoEndpoint: string;
    clientId?: string;
    issuer?: string;
    audience?: string;
    logoutUri?: string;
    authority?: string;
    dashboardMonitor?: {
      config: {
        allowCookies: boolean;
        enableXRay: boolean;
        sessionSampleRate: number;
        telemetries: Array<string>;
        identityPoolId: string;
        guestRoleArn: string;
        endpoint: string;
      };
      appMonitorId: string;
      region: string;
    };
  };
};

export type GetFrontendConfigResponse = SimpleResponse<FrontendConfigResponse>;

export type Config = GetFrontendConfigResponse['data']['attributes'];

export type IsUserForceChangePasswordParams = {
  username: string;
  temporaryPassword: string;
};
